<template>

    <footer class="footer">
        <div class="container">
            <div class="footer__wrapper">
                <div class="footer__logo">
                    <img class="footer__logo-image" src="@/assets/images/nami-logo.png" alt="Служба технической поддержки мобильных и веб-приложений ФГУП НАМИ" title="Служба технической поддержки мобильных и веб-приложений ФГУП НАМИ">
                </div>
                <div class="footer__text">
                    <div class="footer__text-name">
                        Государственный научный центр
                        Российской Федерации
                    </div>
                    <div class="footer__text-rules">
                        <a href="https://nami.ru/uploads/docs/personalData/59c2137bbb90a%D0%9F%D0%B4%D0%BD.pdf" target="_blank" class="footer__text-rules-link">Положение о защите персональных данных</a>
                    </div>
                </div>
                <div class="footer__copyright">
                    <span class="footer__copyright-left">Все права защищены</span>
                    <div class="footer__copyright-right">&copy; ГНЦ РФ ФГУП «НАМИ» 2022</div>
                </div>
            </div>
        </div>
    </footer>

</template>

<style lang="scss">
@import '@/assets/styles/scss/components/footer';
</style>